'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// ./~/react/react.js
// module id = 10
// module chunks = 0 1 2 3 4 5 6 7